import React, { Component } from 'react';
import { useParams, Link } from 'react-router-dom';
import dayjs from 'dayjs';

const STATUS_LABELS = {
    pending: { label:'รอดำเนินการ', color:'#ffc107', icon:'fas fa-clock' },
    contacted: { label:'ติดต่อแล้ว', color:'#17a2b8', icon:'fas fa-phone' },
    quoted: { label:'เสนอราคาแล้ว', color:'#6610f2', icon:'fas fa-file-invoice-dollar' },
    confirmed: { label:'ยืนยันเดินทาง', color:'#28a745', icon:'fas fa-check-circle' },
    closed: { label:'ปิดเคส', color:'#6c757d', icon:'fas fa-times-circle' }
};

class GroupRequestDetailInner extends Component {
    constructor(props) {
        super(props);
        this.state = { req: null, activities: [], loading: true, note: '', status: '', createdBy: '', saving: false };
    }

    componentDidMount() { this.load(); }

    load() {
        var id = this.props.params?.id;
        if (!id) return;
        this.setState({ loading: true });
        fetch('api/grouprequest/' + id)
            .then(r => r.ok ? r.json() : null)
            .then(j => this.setState({ req: j?.request || null, activities: j?.activities || [], loading: false }))
            .catch(() => this.setState({ loading: false }));
    }

    async addActivity() {
        var { note, status, createdBy } = this.state;
        if (!note.trim() && !status) { alert('กรุณาใส่หมายเหตุหรือเปลี่ยนสถานะอย่างน้อย 1 อย่าง'); return; }
        var id = this.props.params?.id;
        this.setState({ saving: true });
        try {
            var r = await fetch('api/grouprequest/' + id + '/activity', {
                method:'POST', headers:{'Content-Type':'application/json'},
                body: JSON.stringify({ note, status, createdBy })
            });
            if (!r.ok) throw new Error('save failed');
            this.setState({ saving: false, note:'', status:'' });
            this.load();
        } catch (e) {
            this.setState({ saving: false });
            alert('บันทึกไม่สำเร็จ: ' + e.message);
        }
    }

    render() {
        var { req, activities, loading, note, status, createdBy, saving } = this.state;
        if (loading) return <div className="text-center py-5"><div className="spinner-border text-danger"></div></div>;
        if (!req) return <div className="text-center py-5"><i className="fas fa-exclamation-circle fa-3x text-muted"></i><div className="mt-3">ไม่พบข้อมูล</div></div>;
        var s = STATUS_LABELS[req.status] || STATUS_LABELS.pending;

        return (
            <div style={{ padding: 20 }}>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <div>
                        <Link to="/console/grouprequest" className="btn btn-outline-secondary btn-sm"><i className="fas fa-arrow-left"></i> กลับรายการ</Link>
                    </div>
                    <span style={{ background:s.color, color:'#fff', padding:'6px 16px', borderRadius:20, fontSize:13, fontWeight:700 }}>
                        <i className={s.icon}></i> {s.label}
                    </span>
                </div>

                <div className="row">
                    <div className="col-md-5">
                        <div style={{ background:'#fff', borderRadius:10, padding:20, boxShadow:'0 2px 12px rgba(0,0,0,0.06)' }}>
                            <h5 style={{ fontWeight:700, marginBottom:16 }}><i className="fas fa-user"></i> ข้อมูลผู้ติดต่อ #{req.id}</h5>
                            <div className="row g-3" style={{ fontSize:14 }}>
                                <div className="col-12"><strong>ชื่อ:</strong> {req.name}</div>
                                <div className="col-md-6"><strong><i className="fas fa-phone"></i> โทร:</strong> {req.phone || '-'}</div>
                                <div className="col-md-6"><strong><i className="fas fa-envelope"></i> อีเมล:</strong> {req.email || '-'}</div>
                                <div className="col-md-6"><strong><i className="fab fa-line"></i> LINE:</strong> {req.line || '-'}</div>
                                <div className="col-md-6"><strong><i className="fas fa-users"></i> จำนวน:</strong> {req.pax > 0 ? req.pax + ' ท่าน' : '-'}</div>
                                <div className="col-md-6"><strong><i className="fas fa-calendar"></i> วันเดินทาง:</strong> {req.travelDate ? dayjs(req.travelDate).format('D MMM YY') : '-'}</div>
                                <div className="col-md-6"><strong><i className="fas fa-coins"></i> งบ:</strong> {req.budget || '-'}</div>
                                <div className="col-12"><strong><i className="fas fa-map-marker-alt"></i> จุดหมาย:</strong> {req.destination || '-'}</div>
                                {req.programCode && (
                                    <div className="col-12"><strong><i className="fas fa-tag"></i> โปรแกรม:</strong> <Link to={'/console/programplus/view/' + req.programId}>{req.programCode} {req.programName}</Link></div>
                                )}
                                {req.note && <div className="col-12"><strong>หมายเหตุจากลูกค้า:</strong><div style={{ background:'#fafafa', padding:10, borderRadius:6, marginTop:4, whiteSpace:'pre-wrap' }}>{req.note}</div></div>}
                                <div className="col-12" style={{ fontSize:12, color:'#888', borderTop:'1px solid #eee', paddingTop:10 }}>
                                    ส่งเมื่อ: {req.createdAt ? dayjs(req.createdAt).format('D MMM YYYY HH:mm') : '-'}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-7">
                        <div style={{ background:'#fff', borderRadius:10, padding:20, boxShadow:'0 2px 12px rgba(0,0,0,0.06)', marginBottom:16 }}>
                            <h5 style={{ fontWeight:700, marginBottom:16 }}><i className="fas fa-plus-circle"></i> บันทึกกิจกรรม</h5>
                            <div className="mb-2">
                                <label style={{ fontSize:13, fontWeight:600 }}>หมายเหตุ</label>
                                <textarea className="form-control" rows="3" placeholder="เช่น โทรติดต่อลูกค้าแล้ว / ส่งใบเสนอราคา..."
                                    value={note} onChange={e=>this.setState({note:e.target.value})}></textarea>
                            </div>
                            <div className="row g-2 mb-2">
                                <div className="col-md-6 d-flex flex-column">
                                    <label style={{ fontSize:13, fontWeight:600, marginBottom:4, display:'block' }}>เปลี่ยนสถานะ (ถ้ามี)</label>
                                    <select className="form-select" style={{ height:38 }} value={status} onChange={e=>this.setState({status:e.target.value})}>
                                        <option value="">— ไม่เปลี่ยน —</option>
                                        {Object.keys(STATUS_LABELS).map(k => <option key={k} value={k}>{STATUS_LABELS[k].label}</option>)}
                                    </select>
                                </div>
                                <div className="col-md-6 d-flex flex-column">
                                    <label style={{ fontSize:13, fontWeight:600, marginBottom:4, display:'block' }}>ผู้บันทึก</label>
                                    <input className="form-control" style={{ height:38 }} placeholder="ชื่อเจ้าหน้าที่" value={createdBy} onChange={e=>this.setState({createdBy:e.target.value})} />
                                </div>
                            </div>
                            <div className="text-end">
                                <button className="btn btn-danger" disabled={saving} onClick={()=>this.addActivity()}>
                                    <i className="fas fa-save"></i> {saving ? 'กำลังบันทึก...' : 'บันทึกกิจกรรม'}
                                </button>
                            </div>
                        </div>

                        <div style={{ background:'#fff', borderRadius:10, padding:20, boxShadow:'0 2px 12px rgba(0,0,0,0.06)' }}>
                            <h5 style={{ fontWeight:700, marginBottom:16 }}><i className="fas fa-history"></i> ประวัติกิจกรรม ({activities.length})</h5>
                            {activities.length === 0 ? (
                                <div style={{ color:'#bbb', textAlign:'center', padding:20 }}>ยังไม่มีบันทึก</div>
                            ) : (
                                <div>
                                    {activities.map(a => {
                                        var ss = STATUS_LABELS[a.status];
                                        return (
                                            <div key={a.id} style={{ borderLeft:'3px solid #dc3545', paddingLeft:12, marginBottom:12 }}>
                                                <div className="d-flex justify-content-between" style={{ fontSize:12, color:'#888' }}>
                                                    <span>{a.createdBy || 'ระบบ'} · {a.createdAt ? dayjs(a.createdAt).format('D MMM YY HH:mm') : ''}</span>
                                                    {ss && <span style={{ background:ss.color, color:'#fff', padding:'2px 8px', borderRadius:12, fontSize:11 }}><i className={ss.icon}></i> {ss.label}</span>}
                                                </div>
                                                {a.note && <div style={{ whiteSpace:'pre-wrap', marginTop:4, fontSize:14 }}>{a.note}</div>}
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export function GroupRequestDetail(props) {
    var params = useParams();
    return <GroupRequestDetailInner {...props} params={params} />;
}
